module.exports = __webpack_public_path__ + "images/mir-6e622d.svg";